module.exports = __webpack_public_path__ + "static/photoshooting-makeup-ffa89b6d24c767e90b46a0ad9c68c610.jpg";